import React from "react";
import { Icon } from "./Icon";

interface Close32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Close32: React.FC<Close32Props> = ({ size, className, color }) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M798.71 843.92c12.496 12.496 32.758 12.496 45.254 0 12.499-12.499 12.499-32.758 0-45.254l-286.704-286.707 286.704-286.706c12.499-12.497 12.499-32.758 0-45.255-12.496-12.497-32.758-12.497-45.254 0l-286.704 286.706-286.707-286.707c-12.497-12.497-32.758-12.497-45.255 0s-12.497 32.758 0 45.255l286.704 286.706-286.704 286.707c-12.497 12.496-12.497 32.755 0 45.254 12.497 12.496 32.758 12.496 45.255 0l286.707-286.707 286.704 286.707z" />
    </Icon>
  );
};
